const Disclaimer = ({ onAccept }) => {
  return (
    <div
      id="default-modal"
      tabIndex="-1"
      aria-hidden="true"
      className="flex overflow-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full"
      style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
    >
      <div className="relative p-4 mx-auto w-full max-w-2xl max-h-full">
        <div className="relative bg-white rounded-lg shadow">
          <div className="flex items-center justify-between p-4 md:p-5 bg-vennre-blue text-sm md:text-lg text-white font-semibold rounded-t-lg">
            <h3 className="text-xl font-semibold">Disclaimer</h3>
          </div>
          <div className="p-4 md:p-5 space-y-4 h-96 lg:h-auto overflow-auto">
            <p className="text-base leading-relaxed text-vennre-gray-01">
              All figures provided are best estimates based on available
              information and assumptions at the time of opportunity
              underwriting. While care has been taken to ensure the accuracy of
              the figures, Vennre accepts no liability for any errors,
              omissions, or inaccuracies in the information provided. Vennre
              does not guarantee or warrant the completeness, correctness,
              reliability, or suitability of the figures for any particular
              purpose. Users of the information provided should conduct their
              own analysis and seek professional advice as necessary.
            </p>
            <p className="text-base leading-relaxed text-vennre-gray-01">
              By utilising this tool, users consent to the storage of their data
              within the platform's infrastructure. Vennre is committed to
              safeguarding the privacy and security of user data and adheres to
              strict data protection standards. The data stored will not be
              shared with any third-party providers without the users’ explicit
              consent.
            </p>
          </div>
          <div className="flex items-center p-4 md:p-5 border-t border-gray-200 rounded-b">
            <button
              onClick={onAccept}
              type="button"
              className="text-white bg-[#1839D4] mx-auto focus:ring-4 focus:outline-none focus:ring-blue-300 font-semibold rounded-[4px] text-[17px] px-6 py-3 text-center"
            >
              I accept
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Disclaimer;
